// MUI
import { createTheme } from "@mui/material/styles";

// Components
import ComponentsOverrides from './overrides';

const theme = createTheme({
  palette: {
    primary: {
      main: "#1DB0BF",
      light: "#63a4ff",
      dark: "#004ba0",
    },
    secondary: {
      main: "#ffffff",
    },
    background: {
      default: "#0E1720",
      paper: "#0E1720",
    },
    text: {
      primary: "#FFFFFF",
      secondary: "#A8B2D1",
    },
  },
  typography: {
    fontFamily: "'Poppins', sans-serif",
  },
});

theme.components = ComponentsOverrides();

export default theme;
